
import { getCountries } from '@/services/country'
export default (amount, countryIsoCodeOrCurrency = null, currency = null) => {
  const countryConfig = getCountries().find(x => x.iso_code === countryIsoCodeOrCurrency || x.currency === countryIsoCodeOrCurrency)
  try {
    // use Company Country `language` because `front_config.i18n.lang` may be customized for SaaS specific transation and could not match to a real Locale
    return parseFloat(amount).toLocaleString(countryConfig.language.replace('_', '-'), { style: 'currency', currency: countryConfig.currency })
  } catch (error) {
    return ''
  }
}
